import '.d{display:flex;}.ssr-plugin'
import '.a8{justify-content:center;}.ssr-plugin'
import '.e{flex-direction:column;}.ssr-plugin'
import '.a7{align-items:center;}.ssr-plugin'
import '.ab{gap:0.5rem;}.ssr-plugin'
import '.ai{cursor:pointer;}.ssr-plugin'
import '.g3{padding:0.75rem;}.ssr-plugin'
import '.ax{border-radius:1.25rem;}.ssr-plugin'
import '.a2{border:var(--border-subtle);}.ssr-plugin'
import '.ad{background-color:var(--palette-white);}.ssr-plugin'
import '.fi{transition:background-color 0.2s ease;}.ssr-plugin'
import '.f1{width:2.5rem;}.ssr-plugin'
import '.cx{height:2.5rem;}.ssr-plugin'
import '.hi{color:var(--palette-blue-700);}.ssr-plugin'
import '.hj{font-size:0.9rem;}.ssr-plugin'
import '.w{font-weight:400;}.ssr-plugin'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { styled } from 'inlines'
import { IconProp } from '@fortawesome/fontawesome-svg-core'
import { MouseEventHandler } from 'react'

export type SocialMediaButtonProps = {
  icon: IconProp
  label: string
  onClick: MouseEventHandler<HTMLButtonElement>
  isMobile?: boolean
}

export const SocialMediaButton = ({
  icon,
  label,
  onClick,
  isMobile,
}: SocialMediaButtonProps) => {
    return (
      <styled.button className="d a8 e a7 ab ai g3 ax a2 ad fi"
        style={{
          '&:hover': {
            backgroundColor: 'var(--palette-blue-50)',
          },
          width: isMobile ? '8rem' : '5.5rem',
          height: isMobile ? '8rem' : '5.5rem',
        }}
        onClick={onClick}
      >
        <div className="f1 cx d a7 a8 hi"
          style={{
            fontSize: isMobile ? '3rem' : '2rem',
          }}
        >
          <FontAwesomeIcon icon={icon} />
        </div>
        <span className="hj hi w"
        >
          {label}
        </span>
      </styled.button>
    )
}